<template>
    <div class="question-address">
        <div class="content-tip">
            您的居住所在地的平均消费水平和社保水平，属于保障确认规划时的重要社会经济因素，规划保障方案时我们需要综合考虑哦~
        </div>
        <div class="title">{{ question }}</div>
        <br />
        <br />
        <br />
        <van-area
            :value="cityCode"
            :area-list="{ province_list, city_list, county_list }"
            @change="areaChange"
            :columns-num="2"
            :visible-item-count="3"
            :item-height="66"
        />
        <div class="flex-box next-box">
            <div @click="back">上一步</div>
            <div @click="onClickNext" class="btn-next" sensor-click>
                选好了
            </div>
        </div>
    </div>
</template>

<script>
import PROVINCES from "@/enum/PROVINCES";
import DISTRICTS from "@/enum/DISTRICTS";
import CITIES from "@/enum/CITIES";

const toObjectType = (arr, obj_key, obj_value) => {
    let obj = {};
    obj_key &&
        arr.forEach((item) => {
            obj_key in item && obj_value in item
                ? (obj[item[obj_key]] = item[obj_value])
                : console.warn(`请确认 obj_key or obj_value `);
        });
    !obj_key &&
        arr.forEach((item) => {
            for (const [key, value] of Object.entries(item)) obj[key] = value;
        });
    return obj;
};

export default {
    data() {
        this.question = "您的居住所在地是？";
        return {
            province_list: toObjectType(PROVINCES, "id", "name"),
            city_list: toObjectType(CITIES, "id", "name"),
            county_list: toObjectType(DISTRICTS, "id", "name"),
        };
    },
    props: {
        index: Number, // 题目顺序
        updateAnswer: Function, // 更新答案
        next: Function,
        back: Function,
        city: String,
        cityCode: String,
    },
    methods: {
        onClickNext(e) {
            const text = e.target.innerText;
            this.sensorsAdd("BDWebClick", {
                $element_content: text,
                $title: `测评页-第${this.index}题`,
            });

            this.sensorsAdd("BDanswerResult", {
                entrance_location: "",
                question_number: this.index,
                question: this.question,
                answer: this.city,
            });
            // 执行校验
            // 校验通过执行next方法
            this.next();
        },
        areaChange(picker, [province, city]) {
            if (city) {
                this.updateAnswer(`${province.name}-${city.name}`, "city");
                this.updateAnswer(city.code, "cityCode");
            } else {
                //台湾、香港、澳门没有城市code
                this.updateAnswer(`${province.name}`, "city");
                this.updateAnswer(province.code, "cityCode");
            }
        },
    },
};
</script>

<style>
.question-address .van-picker {
    background-color: transparent;
}
.question-address .van-picker .van-picker__toolbar {
    display: none;
}
.question-address .van-picker .van-picker__mask {
    background-image: none;
}
.question-address .van-picker-column__item {
    font-size: 0.15rem;
    color: #b1c1d4;
}
.question-address .van-picker-column__item--selected {
    font-size: 0.19rem;
    color: #0f2742;
}
</style>

<style scoped>
.flex-box {
    display: flex;
    justify-content: center;
    align-items: center;
}
.next-box {
    position: fixed;
    bottom: 0;
    width: 100%;
    justify-content: space-between;
    padding: 0.2rem;
    box-sizing: border-box;
    background: transparent;
}
.next-box > div {
    padding: 0.06rem 0.16rem;
    font-size: 0.13rem;
    font-weight: 500;
    color: #bbc3ca;
    line-height: 0.19rem;
}
.next-box > div:nth-child(1) {
    border-radius: 0.15rem;
    border: 1px solid #3b97ff;
    color: #3b97ff;
    background: white;
}
.next-box .btn-next {
    font-size: 0.14rem;
    color: #ffffff;
    background: #3b97ff;
    border-radius: 0.15rem;
}
</style>
